import React, { useEffect, useState } from 'react';
import { LoadingOutlined } from "@ant-design/icons";

import { useLocation } from 'react-router-dom';
import { Button, Col, Modal, Row, Spin, notification } from 'antd';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import Scanter from '../components/STORM/Scanter';
import { createRoute } from '../utils/CustomFunc';

const ScanterPage = ({
    urlEndpoint,
    setPageHeader,
    pageName,
    onFormSubmit,
    urlData,
}) => {
    const antIcon = <Spin indicator={<LoadingOutlined style={{ fontSize: 80 }} />} />;

    const [loading, setLoading] = useState(true);
    const [responseMsg, setResponseMsg] = useState();
    const [selectedButton, setSelectedButton] = useState();
    const urlCode = useSelector(state => state.urlCode);
    const [openModal, setOpenModal] = useState(false);
    const [modalData, setModalData] = useState();
    const { search } = useLocation();
    const searchParams = queryString.parse(search);

    const getData = () => {
        liracrypt.get(urlEndpoint, { ...searchParams, ...urlData })
            .then(response => {
                if (setPageHeader) {
                    setPageHeader(response.data?.config?.pageTitle || pageName);
                }
                setModalData(response.data);
                setLoading(false);
                setOpenModal(true);
            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            })
    }

    useEffect(() => {
        setLoading(true);
        getData();
    }, [search]);


    useEffect(() => {
        let interval;
        if (modalData?.config?.interval) {
            interval = setInterval(() => {
                getData();
            }, modalData?.config?.interval)
        };
        return (() => clearInterval(interval))
    }, [modalData?.config?.interval]);


    const finalAction = (action, res) => {
        if (action === "refreshPhantom") {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } else {
            // notification.success({
            //     message: res?.data?.message
            //         ? res?.data?.message
            //         : "Data Modified Successfully !",
            // });
        }
    };

    const onResponse = async ({ button, onlyPostSubmitAction, response, barCode }) => {
        // setStormResponse(data);
        let btnData = button || selectedButton;
        // if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
        //     return openPopupModal(btnData);
        // };
        if (!btnData?.buttonProp?.postSubmitAction) {
            return;
        };

        // if (btnData?.postSubmitActionProp?.action === "clearForm") {
        //   form.resetFields();
        //   console.log("resetFields33");
        // }
        // if (btnData?.postSubmitActionProp?.action === "blankPage") {
        //   setStormResponse(null);
        // };
        // if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
        //     return document.getElementById("submitButtonForm").click();
        // }
        if (btnData?.postSubmitActionProp?.action === "confirmationPopup") {
            let confirmationPopUp = btnData?.postSubmitActionProp?.confirmationPopup;
            Modal.confirm({
                title: response?.data?.message || confirmationPopUp["text"],
                okText: confirmationPopUp["okButtonLabel"],
                cancelText: confirmationPopUp["cancelButtonLabel"],
                cancelButtonProps: { danger: true, type: 'primary' },
                // okButtonProps: {  },
                onOk: async () => {
                    if (confirmationPopUp?.onOk?.submitFormDataProp) {
                        let csubmitFormDataProp = confirmationPopUp?.onOk?.submitFormDataProp
                        let _response;
                        let urlData = { ...csubmitFormDataProp.params, barCode };
                        if (csubmitFormDataProp?.method === 'POST') {
                            _response = await liracrypt.post(csubmitFormDataProp?.api, { ...urlData })
                        }
                        if (csubmitFormDataProp?.method === 'PATCH') {
                            _response = await liracrypt.patch(csubmitFormDataProp?.api, { ...urlData })
                        }
                        if (csubmitFormDataProp?.method === 'GET') {
                            _response = await liracrypt.get(csubmitFormDataProp?.api, { ...urlData })
                        };
                        if (_response.data.isSuccess) {
                            let cPostSubmitAction = confirmationPopUp?.onOk?.postSubmitActionProp;
                            if (!cPostSubmitAction) {
                                return;
                            }
                            if (cPostSubmitAction?.action === "newTab") {
                                let route = createRoute({
                                    route: cPostSubmitAction?.routeTyp === 'dynamic' ? _response.data.data.route : cPostSubmitAction?.route,
                                    props: cPostSubmitAction?.props,
                                    multiProps: cPostSubmitAction?.multiProps,
                                    params: cPostSubmitAction?.params,
                                    urlCode,
                                    record: response.data.data
                                })
                                return window.open(route, '_blank');
                            };

                            if (cPostSubmitAction?.action === 'reloadPage') {
                                return window.location.reload();
                            }
                        }
                    }
                    if (confirmationPopUp?.onOk?.action === "newTab") {
                        let route = createRoute({
                            route: confirmationPopUp?.onOk?.route,
                            props: confirmationPopUp?.onOk?.props,
                            multiProps: confirmationPopUp?.onOk?.multiProps,
                            params: confirmationPopUp?.onOk?.params,
                            urlCode,
                            record: response.data.data
                        })
                        return window.open(route, '_blank');
                    };

                    if (confirmationPopUp?.onOk?.action === 'reloadPage') {
                        return window.location.reload();
                    }
                }
            });
        };
        if (btnData?.postSubmitActionProp?.action === "newTab") {
            let route = createRoute({
                route: btnData.postSubmitActionProp.route,
                props: btnData.postSubmitActionProp.props,
                multiProps: btnData.postSubmitActionProp.multiProps,
                params: btnData.postSubmitActionProp.params,
                urlCode,
                record: response.data.data
            })
            return window.open(route, '_blank');
        };

        if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
            return window.location.reload();
        }
        finalAction(btnData?.postSubmitActionProp?.action, response)
    };


    const onScanterFinish = ({ button, barCode }) => {
        let postData = {
            ...searchParams,
            ...button?.submitFormDataProp.params, resp: {
                "_id": "X_123Scanter",
                "test": "Liradolf"
            }
        };
        postData.barCode = barCode;
        //    postData.seldocs = selectedRowData;
        // setBarCode(barCode);
        if (button?.submitFormDataProp?.output?.resp) {
            onFormSubmit({ values: { barCode }, config: { ...button?.submitFormDataProp } })
            return;
        }
        if (button?.submitFormDataProp?.method === 'POST') {
            liracrypt.post(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    setResponseMsg(response.data?.data?.responseMsg)
                    // notification.success({ message: response.data.message });
                    onResponse({ button, response, barCode: postData.barCode })
                } else {
                    setResponseMsg(response.data?.data?.responseMsg);
                    notification.error({ message: response.data.message })
                }

            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
        if (button?.submitFormDataProp?.method === 'PATCH') {
            liracrypt.patch(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    //   notification.success({ message: response.data.message });
                    onResponse({ button, response, barCode: postData.barCode })
                } else {
                    notification.error({ message: response.data.message })
                }
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
    }

    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            {
                loading ?
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center',
                        width: '100%'
                    }}>
                        {antIcon}
                    </div> :
                    <>
                        <div style={{ width: '100%', marginTop: 10 }}>
                            <h1 style={{ textAlign: 'center', color: '#ffffff' }}>Scan BarCode Here.</h1>
                            <Scanter
                                onFinish={onScanterFinish}
                                postSubmitAction={onResponse}
                                openPopupModal={() => { }}
                                button={modalData?.config?.scanter}
                                setSelectedButton={setSelectedButton}
                                form={null}
                                label={modalData?.config?.scanter?.buttonProp?.label}
                                type={modalData?.config?.scanter?.buttonProp?.type}
                                disabled={!modalData?.config?.scanter?.buttonProp?.enable}
                                confirmationPopUp={modalData?.config?.scanter?.buttonProp?.confirmationPopUp ? modalData?.config?.scanter?.confirmationPopUpProp : undefined}
                                submitFormData={modalData?.config?.scanter?.submitFormDataProp}
                            />
                        </div>
                    </>
            }
        </div>
    )
};

export default ScanterPage;